import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=6f1c5572&scoped=true&"
import script from "./Notifier.vue?vue&type=script&lang=ts&"
export * from "./Notifier.vue?vue&type=script&lang=ts&"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=6f1c5572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c5572",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
